function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.XO = t() : (e.XO = e.XO || {}, e.XO.ads = e.XO.ads || {}, e.XO.ads.gpt = t());
}(self, function () {
  return function () {
    "use strict";

    var e = {
        d: function d(t, n) {
          for (var r in n) e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
            enumerable: !0,
            get: n[r]
          });
        },
        o: function o(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }
      },
      t = {};
    function n(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function r(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, o(r.key), r);
      }
    }
    function o(e) {
      var t = function (e) {
        if ("object" != i(e) || !e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != i(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == i(t) ? t : t + "";
    }
    function i(e) {
      return i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, i(e);
    }
    e.d(t, {
      "default": function _default() {
        return ve;
      }
    });
    var a = Object.prototype.hasOwnProperty;
    function u(e, t, n) {
      for (var r = e, o = 0; o < t.length; o++) {
        var u = t[o];
        if ("object" !== i(r) || !a.call(r, u)) return n;
        r = r[u];
      }
      return r;
    }
    function l(e, t) {
      for (var n in e) a.call(e, n) && t.call(null, [n, e[n]]);
    }
    var s = function () {
      return e = function e(t) {
        var r = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), l(t, function (e) {
          var t = function (e, t) {
              return function (e) {
                if (Array.isArray(e)) return e;
              }(e) || function (e, t) {
                var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != n) {
                  var r,
                    o,
                    i,
                    a,
                    u = [],
                    l = !0,
                    s = !1;
                  try {
                    if (i = (n = n.call(e)).next, 0 === t) {
                      if (Object(n) !== n) return;
                      l = !1;
                    } else for (; !(l = (r = i.call(n)).done) && (u.push(r.value), u.length !== t); l = !0);
                  } catch (e) {
                    s = !0, o = e;
                  } finally {
                    try {
                      if (!l && null != n["return"] && (a = n["return"](), Object(a) !== a)) return;
                    } finally {
                      if (s) throw o;
                    }
                  }
                  return u;
                }
              }(e, t) || function (e, t) {
                if (e) {
                  if ("string" == typeof e) return n(e, t);
                  var r = {}.toString.call(e).slice(8, -1);
                  return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
                }
              }(e, t) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }();
            }(e, 2),
            o = t[0],
            i = t[1];
          r[o] = i;
        });
      }, (t = [{
        key: "eachPair",
        value: function value(e) {
          return l(this, e);
        }
      }]) && r(e.prototype, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t;
    }();
    function c(e) {
      return c = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, c(e);
    }
    function f(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function d(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, p(r.key), r);
      }
    }
    function g(e, t, n) {
      return t && d(e.prototype, t), n && d(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }
    function p(e) {
      var t = function (e) {
        if ("object" != c(e) || !e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != c(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == c(t) ? t : t + "";
    }
    var y = function () {
        return g(function e(t) {
          var n = t.application;
          f(this, e), this.name = u(n, ["name"]);
        }, [{
          key: "isContent",
          value: function value() {
            return "content" === this.name;
          }
        }, {
          key: "isFashion",
          value: function value() {
            return "fashion" === this.name;
          }
        }]);
      }(),
      m = function () {
        return g(function e(t) {
          var n = t.entities;
          f(this, e), this.primaryEntity = n && n[n.primary_entity_id] || {};
        }, [{
          key: "name",
          value: function value() {
            return (this.primaryEntity.url || "").split("/").pop();
          }
        }, {
          key: "terms",
          value: function value() {
            return new s(this.primaryEntity.terms);
          }
        }]);
      }(),
      v = function () {
        return g(function e() {
          var t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).metadata,
            n = void 0 === t ? {} : t;
          f(this, e), this.metadata = n, this.application = new y(n), this.primaryEntity = new m(n);
        }, [{
          key: "dig",
          value: function value() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            return u.apply(void 0, [this.metadata].concat(t));
          }
        }, {
          key: "adCategory",
          value: function value() {
            return this.dig(["ad_data", "category"]);
          }
        }, {
          key: "adSubCategory",
          value: function value() {
            return this.dig(["ad_data", "sub_category"]);
          }
        }, {
          key: "pageKind",
          value: function value() {
            return this.dig(["page_data", "kind"]);
          }
        }, {
          key: "isResultsPage",
          value: function value() {
            return "results" === this.pageKind();
          }
        }, {
          key: "isTopicPage",
          value: function value() {
            return "topic-page" === this.pageKind();
          }
        }, {
          key: "isDetailPage",
          value: function value() {
            return "detail" === this.pageKind();
          }
        }, {
          key: "pageHasResults",
          value: function value() {
            return this.isTopicPage() || this.isResultsPage();
          }
        }, {
          key: "resultsTerms",
          value: function value() {
            return this.pageHasResults() ? new s(this.dig(["page_data", "results_terms", "terms"], {})) : new s();
          }
        }, {
          key: "shouldEnableBidding",
          value: function value() {
            return !!this.metadata.enable_ad_bidding;
          }
        }, {
          key: "shouldLoadGptAsync",
          value: function value() {
            return !!this.metadata.should_load_gpt_async;
          }
        }, {
          key: "sid",
          value: function value() {
            return this.metadata.sid;
          }
        }]);
      }();
    function b(e) {
      return b = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, b(e);
    }
    function h(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function w(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, T(r.key), r);
      }
    }
    function S(e, t, n) {
      return t && w(e.prototype, t), n && w(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }
    function T(e) {
      var t = function (e) {
        if ("object" != b(e) || !e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != b(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == b(t) ? t : t + "";
    }
    var P = function () {
        return S(function e(t) {
          var n = t.href;
          h(this, e), this.href = n;
        }, [{
          key: "isFashionResultsPage",
          value: function value() {
            var e = this.href.split("/").pop();
            return new RegExp(["wedding-dresses", "bridesmaid-dresses", "flower-girl-dresses", "mother-of-the-bride-dresses", "engagement-rings", "wedding-rings", "accessories", "wedding-accessories", "wedding-jewelry", "tuxedos", "wedding-hair-pins-combs-clips", "wedding-shoes"].join("|")).test(e);
          }
        }]);
      }(),
      _ = function () {
        return S(function e(t) {
          var n = t.location;
          h(this, e), this.search = n.search;
        }, [{
          key: "currentPageNumber",
          value: function value() {
            var e = this.search.match(/page=(\d+)/),
              t = e && e[1] || 1;
            return Number(t);
          }
        }, {
          key: "adOpsQa",
          value: function value() {
            var e = this.search.match(/adopsqa=([^?#/\\&=]+)/);
            return e && e[1];
          }
        }]);
      }(),
      E = function () {
        return S(function e(t) {
          var n = t.window;
          h(this, e), this.window = n, this.document = n.document, this.query = new _(n), this.location = new P(n.location);
        }, [{
          key: "isDesktop",
          value: function value() {
            return this.window.innerWidth > 768;
          }
        }, {
          key: "adSlotIsAboveFold",
          value: function value(e) {
            var t = this.document.getElementById(e.getSlotElementId());
            return this.elementIsAboveTheFold(t);
          }
        }, {
          key: "elementIsAboveTheFold",
          value: function value(e) {
            if (!e) return !1;
            var t = e.getBoundingClientRect().top + 1;
            return this.isDesktop() ? t < 950 : t < 1800;
          }
        }, {
          key: "deviceType",
          value: function value() {
            return this.isDesktop() ? "desktop" : "mobile";
          }
        }, {
          key: "wasReferedByCurrentDomain",
          value: function value() {
            return this.document.referrer.indexOf(this.document.domain) >= 0;
          }
        }]);
      }();
    function k(e) {
      return k = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, k(e);
    }
    function j(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, I(r.key), r);
      }
    }
    function I(e) {
      var t = function (e) {
        if ("object" != k(e) || !e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != k(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == k(t) ? t : t + "";
    }
    var O = function () {
      return e = function e(t) {
        var n = t.browser;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.browser = n;
      }, (t = [{
        key: "apply",
        value: function value(e) {
          var t = this.browser;
          e.setTargeting("device-type", t.deviceType()), e.setTargeting("first-imp", String(!t.wasReferedByCurrentDomain())), e.setTargeting("page", String(t.query.currentPageNumber())), t.query.adOpsQa() && e.setTargeting("adopsqa", t.query.adOpsQa());
        }
      }]) && j(e.prototype, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t;
    }();
    function A(e) {
      return A = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, A(e);
    }
    function C(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, R(r.key), r);
      }
    }
    function R(e) {
      var t = function (e) {
        if ("object" != A(e) || !e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != A(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == A(t) ? t : t + "";
    }
    var B = function () {
      return e = function e(t) {
        var n = t.browser;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.browser = n;
      }, (t = [{
        key: "apply",
        value: function value(e) {
          var t = this.browser;
          e.setTargeting("premium", t.adSlotIsAboveFold(e));
        }
      }]) && C(e.prototype, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t;
    }();
    function U(e, t, n) {
      var r = e.getTargeting(t);
      0 !== r.length && e.setTargeting(n, r);
    }
    function x(e) {
      return x = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, x(e);
    }
    function D(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
          var r,
            o,
            i,
            a,
            u = [],
            l = !0,
            s = !1;
          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              l = !1;
            } else for (; !(l = (r = i.call(n)).done) && (u.push(r.value), u.length !== t); l = !0);
          } catch (e) {
            s = !0, o = e;
          } finally {
            try {
              if (!l && null != n["return"] && (a = n["return"](), Object(a) !== a)) return;
            } finally {
              if (s) throw o;
            }
          }
          return u;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return L(e, t);
          var n = {}.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? L(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function L(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function M(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, z(r.key), r);
      }
    }
    function z(e) {
      var t = function (e) {
        if ("object" != x(e) || !e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != x(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == x(t) ? t : t + "";
    }
    var N = function () {
      return e = function e(t) {
        var n = t.xoMetadata,
          r = t.browser;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.xoMetadata = n, this.browser = r;
      }, (t = [{
        key: "apply",
        value: function value(e) {
          var t = this.xoMetadata,
            n = this.browser;
          e.setTargeting("page-type", t.pageKind()), this.setSidTargeting(e), t.resultsTerms().eachPair(function (t) {
            var n = D(t, 2),
              r = n[0],
              o = n[1];
            e.setTargeting(r, o);
          }), function (e, t) {
            return t.isDetailPage() || t.application.isFashion() && e.location.isFashionResultsPage();
          }(n, t) && t.primaryEntity.terms().eachPair(function (t) {
            var n = D(t, 2),
              r = n[0],
              o = n[1];
            e.setTargeting(r, o);
          }), t.application.isFashion() && this.updateFashionTargeting(e);
        }
      }, {
        key: "setSidTargeting",
        value: function value(e) {
          var t = this.xoMetadata,
            n = t.sid();
          !n && t.application.isContent() && (n = t.primaryEntity.name()), n && e.setTargeting("sid", n);
        }
      }, {
        key: "updateFashionTargeting",
        value: function value(e) {
          var t = this.xoMetadata;
          if (U(e, "category_name", "wedding-categories"), U(e, "category_name", "wedding_categories"), e.clearTargeting("description"), e.clearTargeting("fullPath"), e.clearTargeting("path"), e.clearTargeting("id"), t.isResultsPage()) {
            var n = t.resultsTerms().designer_id || [];
            n.length ? e.setTargeting("designer_id", n) : e.clearTargeting("designer_id");
          }
        }
      }]) && M(e.prototype, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t;
    }();
    function F() {
      U(this, "topic-page", "iastopicpage"), U(this, "wedding_activities", "iasweddingactivities"), U(this, "wedding_categories", "iasweddingcategories"), U(this, "device-type", "iasdevicetype");
    }
    function q(e) {
      return q = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, q(e);
    }
    function K(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, X(r.key), r);
      }
    }
    function X(e) {
      var t = function (e) {
        if ("object" != q(e) || !e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != q(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == q(t) ? t : t + "";
    }
    var H = function () {
      return e = function e(t) {
        var n = t.applicationName;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.applicationName = n;
      }, (t = [{
        key: "toString",
        value: function value() {
          return "/".concat(4879, "/").concat(this.applicationName, ".n_TK");
        }
      }]) && K(e.prototype, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t;
    }();
    function V(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
          var r,
            o,
            i,
            a,
            u = [],
            l = !0,
            s = !1;
          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              l = !1;
            } else for (; !(l = (r = i.call(n)).done) && (u.push(r.value), u.length !== t); l = !0);
          } catch (e) {
            s = !0, o = e;
          } finally {
            try {
              if (!l && null != n["return"] && (a = n["return"](), Object(a) !== a)) return;
            } finally {
              if (s) throw o;
            }
          }
          return u;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Q(e, t);
          var n = {}.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Q(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function Q(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    var $ = [[728, 90], [970, 90], [350, 250], [300, 600], [160, 600], [300, 250], [320, 50]];
    function G(e) {
      var t = V(e, 2),
        n = t[0],
        r = t[1];
      return $.filter(function (e) {
        var t = V(e, 2),
          o = t[0],
          i = t[1];
        return o === n && i === r;
      }).length > 0;
    }
    function W(e) {
      return {
        slotName: e.getAdUnitPath(),
        slotID: e.getSlotElementId(),
        sizes: e.getSizes().map(function (e) {
          return [e.getWidth(), e.getHeight()];
        }).filter(G)
      };
    }
    function J(e) {
      return J = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, J(e);
    }
    function Y(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Z(r.key), r);
      }
    }
    function Z(e) {
      var t = function (e) {
        if ("object" != J(e) || !e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != J(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == J(t) ? t : t + "";
    }
    function ee(e) {
      return Array.isArray(e) && 2 === e.length && e.every(function (e) {
        return "number" == typeof e;
      });
    }
    var te = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._setIdSelector(t), this.targeting = t.targeting || [], this.sizes = function (e) {
          if (!Array.isArray(e)) return [];
          var t = e;
          return ee(e) && (t = [e]), t.forEach(function (e) {
            ee(e) || console.warn("Invalid size: ".concat(e, ". Must be a two element array of numbers"));
          }), t;
        }(t.sizes), this.subAdUnitPath = t.subAdUnitPath || "", this.postRenderCallback = t.postRenderCallback, this.postCreateCallback = t.postCreateCallback;
      }, (t = [{
        key: "_setIdSelector",
        value: function value(e) {
          var t = document.getElementById(e.idSelector);
          if (t) {
            if (this._containsAd(t)) return void console.warn('There is already an ad in the element with the ID selector of "'.concat(e.idSelector, '". Try using refreshAdSlot to refresh the ad call or check your ad call parameters.'));
            this.idSelector = e.idSelector;
          } else console.warn("There is no element with the ID selector of ".concat(e.idSelector, '" on the page.'));
        }
      }, {
        key: "_containsAd",
        value: function value(e) {
          for (var t = e.childNodes, n = 0; n < t.length; n++) {
            var r = t[n];
            if ("IFRAME" === r.tagName || "DIV" === r.tagName) return !0;
          }
          return !1;
        }
      }]) && Y(e.prototype, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t;
    }();
    function ne(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function re(e) {
      return re = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, re(e);
    }
    function oe(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ie(r.key), r);
      }
    }
    function ie(e) {
      var t = function (e) {
        if ("object" != re(e) || !e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, "string");
          if ("object" != re(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" == re(t) ? t : t + "";
    }
    window.googletag = window.googletag || {}, window.googletag.cmd = window.googletag.cmd || [];
    var ae = function ae() {},
      ue = new Map();
    function le(e) {
      googletag.cmd.push(e);
    }
    function se(e, t) {
      void 0 !== window.__iasPET && __iasPET.queue.push({
        adSlots: {
          adSlotId: e.getSlotElementId(),
          size: e.getSizes().map(function (e) {
            return "width" in e && "height" in e ? [e.getWidth(), e.getHeight()] : [1, 1];
          }),
          adUnitPath: e.getAdUnitPath()
        },
        dataHandler: t
      });
    }
    var ce = function () {
      return e = function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = t.adUnitPath,
          r = t.sharedTargeting,
          o = void 0 === r ? [] : r,
          i = t.enableLazyLoad,
          a = void 0 === i ? void 0 : i;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.adSlots = ["null"], this.adUnitPath = n, this.sharedTargeting = o, this.enableLazyLoad = a, le(function () {
          googletag.pubads().addEventListener("slotRequested", function (e) {
            var t = e.slot;
            ue.has(t.getSlotElementId()) && ue["delete"](t.getSlotElementId());
          });
        });
      }, (t = [{
        key: "getSlots",
        value: function value() {
          return this.adSlots.slice(1);
        }
      }, {
        key: "getSlotById",
        value: function value(e) {
          return this.getSlots().filter(function (t) {
            return t.getSlotElementId() === e;
          })[0];
        }
      }, {
        key: "createSlot",
        value: function value(e) {
          var t = this,
            n = e.sizes,
            r = e.idSelector,
            o = e.targeting,
            i = e.subAdUnitPath,
            a = e.postRenderCallback,
            u = e.postCreateCallback,
            l = void 0 === u ? ae : u;
          r && le(function () {
            function e() {
              var e = this;
              googletag.display(r), setTimeout(function () {
                e._handleLazyLoadAndRefresh(r);
              }, 1e3), "function" == typeof a && this._handlePostRenderCallback(s, a);
            }
            var u = t.adUnitPath.toString() + i,
              s = googletag.defineSlot(u, n, r);
            if (l(s), t._setSlotLevelTargeting(s, o), t.adSlots.push(s), s.setTargeting("refresh", r), s.addService(googletag.pubads()), s.setCollapseEmptyDiv(!0, !0), ue.set(r, s), googletag.enableServices(), "undefined" != typeof __iasPET || void 0 !== window.__iasPET) {
              var c = setTimeout(e.bind(t), 3e3);
              se(s, function () {
                clearTimeout(c), __iasPET.setTargetingForGPT(), e.call(t);
              });
            } else e.call(t);
          });
        }
      }, {
        key: "createOutOfPageSlot",
        value: function value(e) {
          var t = this,
            n = e.idSelector,
            r = e.targeting,
            o = e.postCreateCallback,
            i = void 0 === o ? ae : o;
          n && le(function () {
            var e = googletag.defineOutOfPageSlot(t.adUnitPath.toString(), n);
            function o() {
              googletag.display(e.getSlotElementId());
            }
            if (i(e), t._setSlotLevelTargeting(e, r), e.addService(googletag.pubads()), googletag.enableServices(), "undefined" != typeof __iasPET || void 0 !== window.__iasPET) {
              var a = setTimeout(o, 2e3);
              se(e, function () {
                clearTimeout(a), o();
              });
            } else o();
          });
        }
      }, {
        key: "refreshAdSlot",
        value: function value(e, t) {
          this.adSlots[e] ? (this._setRefreshAdSlotTargeting(e, t), googletag.pubads().refresh([this.adSlots[e]])) : console.warn("Ad slot index of ".concat(e, " does not exist on page."));
        }
      }, {
        key: "_setRefreshAdSlotTargeting",
        value: function value(e, t) {
          if ("object" === re(t)) for (var n = 0; n < t.length; n++) this.adSlots[e].setTargeting(t[n][0], t[n][1]);
        }
      }, {
        key: "_setSlotLevelTargeting",
        value: function value(e, t) {
          e.setTargeting("identifier", e.getSlotElementId()), this.sharedTargeting.forEach(function (t) {
            t.apply(e);
          }), t.forEach(function (t) {
            var n = function (e, t) {
                return function (e) {
                  if (Array.isArray(e)) return e;
                }(e) || function (e, t) {
                  var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                  if (null != n) {
                    var r,
                      o,
                      i,
                      a,
                      u = [],
                      l = !0,
                      s = !1;
                    try {
                      if (i = (n = n.call(e)).next, 0 === t) {
                        if (Object(n) !== n) return;
                        l = !1;
                      } else for (; !(l = (r = i.call(n)).done) && (u.push(r.value), u.length !== t); l = !0);
                    } catch (e) {
                      s = !0, o = e;
                    } finally {
                      try {
                        if (!l && null != n["return"] && (a = n["return"](), Object(a) !== a)) return;
                      } finally {
                        if (s) throw o;
                      }
                    }
                    return u;
                  }
                }(e, t) || function (e, t) {
                  if (e) {
                    if ("string" == typeof e) return ne(e, t);
                    var n = {}.toString.call(e).slice(8, -1);
                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ne(e, t) : void 0;
                  }
                }(e, t) || function () {
                  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
              }(t, 2),
              r = n[0],
              o = n[1];
            e.setTargeting(r, o);
          });
        }
      }, {
        key: "_handlePostRenderCallback",
        value: function value(e, t) {
          googletag.pubads().addEventListener("slotRenderEnded", function (n) {
            n.slot.getSlotElementId() === e.getSlotElementId() && (n.isEmpty ? t(e.getSlotElementId(), !1) : t(e.getSlotElementId(), !0));
          });
        }
      }, {
        key: "_handleLazyLoadAndRefresh",
        value: function value(e) {
          if (!this.enableLazyLoad) {
            var t = !0;
            try {
              t = Object.keys(document.getElementById(e).dataset).join().toLowerCase().includes("lazy");
            } catch (e) {
              t = !1;
            }
            ue.has(e) && !t && googletag.pubads().refresh([ue.get(e)], {
              changeCorrelator: !1
            });
          }
        }
      }]) && oe(e.prototype, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t;
    }();
    function fe(e) {
      return decodeURIComponent(e).replace(/^"|"$/g, "");
    }
    function de(e) {
      var t,
        n = null == e ? void 0 : e.publicApiKey,
        r = null == e ? void 0 : e.workspaceId,
        o = null == e || null === (t = e.pageViewProps) || void 0 === t ? void 0 : t.contentTags,
        i = document.createElement("script");
      i.type = "text/javascript", i.innerHTML = '\n    !function(e,o,n,i){if(!e){e=e||{},window.permutive=e,e.q=[];var t=function(){return([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,function(e){return(e^(window.crypto||window.msCrypto).getRandomValues(new Uint8Array(1))[0]&15>>e/4).toString(16)})};e.config=i||{},e.config.apiKey=o,e.config.workspaceId=n,e.config.environment=e.config.environment||"production",(window.crypto||window.msCrypto)&&(e.config.viewId=t());for(var g=["addon","identify","track","trigger","query","segment","segments","ready","on","once","user","consent"],r=0;r<g.length;r++){var w=g[r];e[w]=function(o){return function(){var n=Array.prototype.slice.call(arguments,0);e.q.push({functionName:o,arguments:n})}}(w)}}}(window.permutive,"'.concat(n, '","').concat(r, '",{"consentRequired": false});\n    window.googletag=window.googletag||{},window.googletag.cmd=window.googletag.cmd||[],window.googletag.cmd.push(function(){if(0===window.googletag.pubads().getTargeting("permutive").length){var e=window.localStorage.getItem("_pdfps");window.googletag.pubads().setTargeting("permutive",e?JSON.parse(e):[]);var o=window.localStorage.getItem("permutive-id");o&&(window.googletag.pubads().setTargeting("puid",o),window.googletag.pubads().setTargeting("ptime",Date.now().toString())),window.permutive.config.viewId&&window.googletag.pubads().setTargeting("prmtvvid",window.permutive.config.viewId),window.permutive.config.workspaceId&&window.googletag.pubads().setTargeting("prmtvwid",window.permutive.config.workspaceId)}});\n    permutive.addon(\'web\',{\n      "page": {\n        "contentTags": ').concat(o, ",\n        ").concat(function (e) {
        try {
          return delete e.contentTags, JSON.stringify(e).slice(1, -1);
        } catch (e) {
          return console.error("Error parsing pageViewProps", e), "";
        }
      }(null == e ? void 0 : e.pageViewProps), "\n      }\n    });\n  "), document.head.appendChild(i);
      var a = document.createElement("script");
      a.async = !0, a.src = "https://".concat(r, ".edge.permutive.app/").concat(r, "-web.js"), document.head.appendChild(a), function (e, t) {
        try {
          var n = t.userId,
            r = t.anonymousId;
          permutive.consent({
            opt_in: !0,
            token: e
          });
          var o = [];
          n && o.push({
            id: fe(n),
            tag: "ajs_user_id",
            priority: 0
          }), r && o.push({
            id: fe(r),
            tag: "ajs_anonymous_id",
            priority: 0
          }), permutive.identify(o);
        } catch (e) {
          console.error("Error retrieving cookies", e);
        }
      }(n, e.identifyProps);
    }
    var ge = ["enableBidding", "permutiveConfig", "enableIAS"];
    function pe(e) {
      var t = e.asyncApsTag,
        n = void 0 === t || t;
      !function (e, t, r, o, i, a, u) {
        function l(n, r) {
          t[e]._Q.push([n, r]);
        }
        t[e] || (t[e] = {
          init: function init() {
            l("i", arguments);
          },
          fetchBids: function fetchBids() {
            l("f", arguments);
          },
          setDisplayBids: function setDisplayBids() {},
          _Q: []
        }, (a = r.createElement(o)).async = n, a.src = "https://c.amazon-adsystem.com/aax2/apstag.js", (u = r.getElementsByTagName(o)[0]).parentNode.insertBefore(a, u));
      }("apstag", window, document, "script");
    }
    function ye(e) {
      var t = e.asyncTag,
        n = void 0 === t || t,
        r = e.src,
        o = void 0 === r ? "" : r,
        i = document.createElement("script");
      return i.src = o, i.async = n, document.head.appendChild(i), i;
    }
    function me(e, t, n, r) {
      n && e.length > 0 ? t() : googletag.pubads().refresh(r);
    }
    var ve = {
      _gptSingleton: null,
      version: "4.2.2",
      paths: {
        TheKnotAdUnitPath: H
      },
      configPresets: {
        TheKnotLegacy: function TheKnotLegacy() {
          var e = new v(window.XO),
            t = new E({
              window: window
            });
          return {
            enableBidding: e.shouldEnableBidding(),
            adUnitPath: new H({
              applicationName: e.application.name
            }),
            sharedTargeting: [new O({
              browser: t
            }), new B({
              browser: t
            }), new N({
              browser: t,
              xoMetadata: e
            }), F]
          };
        },
        TheKnotCore: function TheKnotCore(e) {
          var t = e.applicationName,
            n = new E({
              window: window
            });
          return {
            enableBidding: !0,
            adUnitPath: new H({
              applicationName: t
            }),
            sharedTargeting: [new O({
              browser: n
            }), new B({
              browser: n
            }), F]
          };
        }
      },
      loadApsTag: pe,
      loadPermutiveTag: de,
      adSlots: function adSlots() {
        return this._gptSingleton.adSlots;
      },
      addAsyncSlot: function addAsyncSlot(e) {
        this._gptSingleton.createSlot(new te(e));
      },
      refreshAdSlot: function refreshAdSlot(e, t) {
        this._gptSingleton.refreshAdSlot(e, t);
      },
      createOutOfPageSlot: function createOutOfPageSlot(e) {
        this._gptSingleton.createOutOfPageSlot(new te(e));
      },
      getSlotById: function getSlotById(e) {
        return this._gptSingleton.getSlotById(e);
      },
      restrictDataProcessing: function restrictDataProcessing(e) {
        googletag.pubads().setPrivacySettings({
          restrictDataProcessing: e
        });
      },
      initialize: function initialize(e) {
        this._gptSingleton ? console.warn("XO.ads.gpt can only be initialized once") : (function (e) {
          var t,
            n = e.enableBidding,
            r = e.permutiveConfig,
            o = e.enableIAS,
            i = void 0 === o || o,
            a = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = function (e, t) {
                  if (null == e) return {};
                  var n = {};
                  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
                    if (t.includes(r)) continue;
                    n[r] = e[r];
                  }
                  return n;
                }(e, t);
              if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);
                for (r = 0; r < i.length; r++) n = i[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
              }
              return o;
            }(e, ge);
          null != r && r.enable && de(r), n && pe(a), i && (void 0 === window.__iasPET ? ye({
            src: "https://static.adsafeprotected.com/iasPET.1.js",
            asyncTag: !0
          }).onload = function () {
            __iasPET.pubId = "931672", __iasPET.setTargetingForGPT();
          } : __iasPET.pubId = __iasPET.pubId || "931672"), ye({
            src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
            asyncTag: void 0 === (t = a.asyncGpt) || t
          });
        }(e), window.UnionConsentManagement && googletag.cmd.push(function () {
          googletag.pubads().disableInitialLoad();
        }), e.enableBidding && (this._biddingEnabled = !0, window.UnionConsentManagement ? window.UnionConsentManagement.registerService({
          name: "apstag",
          setup: function setup(e) {
            var t = {
              pubID: "3426",
              adServer: "googletag",
              bidTimeout: 2e3
            };
            e.consentedToTargeting || (t.params = {
              aps_privacy: "1YY"
            }), apstag.init(t);
          }
        }) : apstag.init({
          pubID: "3426",
          adServer: "googletag",
          bidTimeout: 2e3
        }), googletag.cmd.push(function () {
          googletag.pubads().disableInitialLoad(), googletag.pubads().enableSingleRequest();
        })), this._gptSingleton = new ce(e));
      },
      fetchVideoBids: function fetchVideoBids(e) {
        return new Promise(function (t) {
          apstag.fetchBids({
            slots: [{
              slotID: e,
              mediaType: "video"
            }]
          }, function (e) {
            t(e);
          });
        });
      },
      renderAds: function renderAds(e) {
        var t = this;
        googletag.cmd.push(function () {
          var n = e || t._gptSingleton.getSlots(),
            r = n.filter(function (e) {
              return e.getSizes().some(function (e) {
                var t = e.width,
                  n = e.height;
                return !(1 === t && 1 === n);
              });
            }),
            o = function o() {
              apstag.fetchBids({
                slots: r.map(W),
                timeout: 2e3
              }, function () {
                apstag.setDisplayBids(), googletag.pubads().refresh(n);
              });
            };
          window.UnionConsentManagement ? window.UnionConsentManagement.registerService({
            name: "googletag",
            setup: function setup(e) {
              t.restrictDataProcessing(!e.consentedToTargeting), me(r, o, t._biddingEnabled, n);
            }
          }) : me(r, o, t._biddingEnabled, n);
        });
      }
    };
    return t["default"];
  }();
});